// 📄 pages/Proyectos/components/ModuloGate.tsx
// Envuelve una ruta de un módulo especializado (hoy SAP Ariba): si el
// proyecto no lo tiene activo, muestra un mensaje claro en vez de la vista
// (alguien puede llegar directo por URL o por un favorito). Mismo patrón que
// SolucionGate.tsx, un nivel más arriba (ver plan-proyectos-generales.md).
import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useProject } from '../../../context/ProjectContext.tsx';
import { MODULOS, ModuloId, tieneModulo } from '../modulosConfig.ts';

export default function ModuloGate({ modulo, children }: { modulo: ModuloId; children: React.ReactNode }) {
  const { project, projectId } = useProject();
  if (!project) return null;
  if (tieneModulo(project, modulo)) return <>{children}</>;

  return (
    <div className="bg-white/5 border border-white/10 rounded-2xl p-10 text-center max-w-xl mx-auto">
      <Lock className="w-8 h-8 mx-auto mb-3 text-gray-500" />
      <h3 className="text-lg font-semibold text-white mb-2">Este proyecto no usa {MODULOS[modulo].label}</h3>
      <p className="text-sm text-gray-400 mb-5">{MODULOS[modulo].descripcion}</p>
      <Link
        to={`/proyecto/${projectId}/editar`}
        className="inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-lg text-sm font-semibold transition-all"
      >
        Activarlo en Editar Proyecto
      </Link>
    </div>
  );
}
